/**
 * Formats a slug/snake_case status string into a proper display label.
 * e.g. "in_progress" -> "In Progress", "not_applicable" -> "Not Applicable"
 */
export const formatStatus = (status) => {
  if (!status) return '';
  return status
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
